<template>
  <dl class="post_dl">
    <dt class="dt-title">{{ title ? title : $t("S20054") }}</dt>
    <div class="vertical-scroll-wrapper">
      <div
        class="study-box"
        v-for="study in data"
        :key="study.id"
        @click="moveToDetail(study)"
      >
        <div
          v-if="study.thumbnail && study.thumbnail.length > 0"
          class="study-box-img"
          :style="`background: url(${study.thumbnail}) center`"
        ></div>
        <div
          class="study-box-info"
          :class="{
            'border-radius-8': !(study.thumbnail && study.thumbnail.length > 0),
          }"
        >
          <div class="study-box-title">
            {{ `${study.name}` }}
          </div>
          <div class="study-box-text__wrapper">
            <span class="study-box-text"> {{ study.category.text }} </span>
            <div class="study-box-name">
              <span class="study-box-text">by </span>
              {{ study.teacher && study.teacher.name && study.teacher.name.fullName ? study.teacher.name.fullName : "" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </dl>
</template>

<script>
/**
 * 메인화면 컨텐츠 카드 컴포넌트
 * @author jaehyub.lee@emcast.com
 * @since 2024.01.11
 */

export default {
  name: "MainContentCard",
  props: ["data", "title"],

  methods: {
    moveToDetail(data) {
      this.$emit("moveToDetail", data);
    },
  },
};
</script>

<style scoped>
.study-box {
  min-width: 230px;
  min-height: 240px;
  max-width: 230px;
  max-height: 240px;
  border-radius: 8px;
  margin-right: 12px;
}
.study-box-img {
  height: 50%;
  background: #ffffff;
  background-size: cover !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
}
.study-box-info {
  height: 50%;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  padding: 14px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.study-box-title {
  font-size: 14px;
  color: #505050;
  font-weight: 500;
}
.study-box-text {
  font-size: 12px;
  color: #acb4be;
}
.study-box-name {
  font-size: 12px;
  color: #505050;
}
.dt-title {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  color: #212121;
}
.border-radius-8 {
  border-radius: 8px !important;
}
</style>